import Table from './Table'
import Dialog from './Dialog'

export default {
    install: Vue => {
        Vue.component('rv-table', Table),
            Vue.component('rv-dialog', Dialog)
    }
}
